
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class QuicklinkService extends CommonService {
	async getQuicklinks(params?: { [key: string]: string | boolean }) {
		const query = generateQueryParams(params);
		return await this.get(`quick-links/?${query}`);
	}
	async getQuicklinkDetails(id: string) {
		return await this.get(`quick-links/${id}`)
	}
	async createQuicklink(parmas: { [key: string]: boolean | string }) {
		return await this.post('quick-links', parmas)
	}
	async updateQuicklink(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`quick-links/${id}`, params)
	}
	
	async deleteQuicklink(id: string) {
		return await this.delete(`quick-links/${id}`)
	}
}
export const quicklinkService = new QuicklinkService();
